import { useSearchParams } from "react-router-dom"
import dataApplicationsContext from "../../context/dataApplicationsContext";
import { useContext, useEffect, useState } from "react";
import { pluralize } from "../../components/pluralize";
import CardHelpLink from "./CardHelpLink";
import SearchInput from "./SearchInput";
import { useSearchResults } from "../../hooks/useSearchResults";

const SearchResults = () => {  
  const [searchParams] = useSearchParams();
  const [displayArticles, setDisplayArticles] = useState([]);
  const query = searchParams.get('q'); // Récupère la valeur du paramètre 'q'
  const { windowWidth } = useContext(dataApplicationsContext);

  const scoredResults = useSearchResults(query);
  const nbArticlesMax = 10;
  const [pagesIndex, setPagesIndex] = useState(0);
  const [nbTotalPages, setNbTotalPages] = useState(1);

  useEffect(() => {
    if (query.length > 0) {
      setDisplayArticles(scoredResults);
      setNbTotalPages(Math.ceil(scoredResults?.length / nbArticlesMax));
    } 
  }, [query, scoredResults]);

  const handleChangePage = (value, forceValue) => {
    window.scrollTo(0,0)
    if (forceValue) {
      setPagesIndex(value)
    } else {
      setPagesIndex(prev => prev + value)
    }
  }

  const maxResult = ((pagesIndex + 1) * nbArticlesMax) >= displayArticles.length ? displayArticles.length : ((pagesIndex + 1) * nbArticlesMax);
  const resultCount = displayArticles?.length === 0
    ? `No Rep ! Pas de résultat pour  " ${query} "`
    : `${displayArticles.length} ${pluralize(displayArticles.length, 'correspondance')}`;

  return (
    <div className="user-setting-container help home mb-100">
      {windowWidth < 744 && 
        <SearchInput formClass={`chart-search-container w-100p mr-0 cursor-pointer`} readOnly wrapperClass="pos-rel z-10 fl-gr-1 max-w-450"/>
      }
      <h1 className="user-title fz-24 mb-4">Résultats de recherche</h1>
      <p className="fw-500 fz-16 op-7">{resultCount}</p>
      <div className="articles-container max-w-750">
        {displayArticles.slice((pagesIndex * nbArticlesMax), ((pagesIndex + 1) * nbArticlesMax)).map((article, index) => {
          return (
            <CardHelpLink key={index}
              title={article.title} link={article.link} slug={article.slug}
              slugClass='fw-600 fz-14 mb-8 op-7' description={article.description}
              containerClass="help-link-container" titleClass="help-link-text" descriptionClass="help-description fz-14 op-7" 
            />
          )
        })}
      </div>
      {nbTotalPages > 1 && 
        <div className="pages-index-wrapper">
          <div className="pages-index-container">
            <i className={`bi bi-chevron-left chevron-change-page ${pagesIndex === 0 ? 'disabled' : ''}`} onClick={() => handleChangePage(-1)}></i>
            <div className="number-page-index-container">
              {Array.from({length: nbTotalPages}, (_, i) => (
                <p 
                  key={i + 1} className={`number-page-index ${pagesIndex + 1 === i + 1 ? 'active' : ''}`}
                  onClick={() => handleChangePage(i, 'forceValue')}
                >
                  {i + 1}
                </p>
              ))}
            </div>
            <i className={`bi bi-chevron-right chevron-change-page ${pagesIndex === (nbTotalPages - 1) ? 'disabled' : ''}`} onClick={() => handleChangePage(1)}></i>
          </div>
          <p className="number-page-resultat">
              {pluralize(displayArticles.length, 'Résultat')} : {(pagesIndex * nbArticlesMax) + 1}-{maxResult} sur {displayArticles.length}</p>
        </div>
      }
    </div>
  )
}

export default SearchResults